"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chain_1 = require("./chain");
const spec_1 = require("./spec");
const utils_1 = require("./utils");
class AccountID {
    constructor(params) {
        if (typeof params === "string") {
            params = AccountID.parse(params);
        }
        this.chainId = new chain_1.ChainID(params.chainId);
        this.address = params.address;
    }
    static parse(id) {
        if (!utils_1.isValidId(id, this.spec)) {
            throw new Error(`Invalid ${this.spec.name} provided: ${id}`);
        }
        return new AccountID(utils_1.getParams(id, this.spec)).toJson();
    }
    static format(params) {
        return utils_1.joinParams(params, this.spec);
    }
    toString() {
        return AccountID.format(this.toJson());
    }
    toJson() {
        return {
            chainId: this.chainId.toJson(),
            address: this.address,
        };
    }
}
exports.AccountID = AccountID;
AccountID.spec = spec_1.CAIP["10"];
//# sourceMappingURL=account.js.map